import { PoleState } from './types';

const state = (): PoleState => {
  return {
    poles: [],
  };
};

export default state;
